<template>
  <div>
    <SelectMinMax
      v-if="displaySelectFull"
      :name="name"
      :type_list="type_list"
      :search="search"
      :label="label"
      :min="parseInt(min)"
      :max="parseInt(max)"
      :default-value="[filters?.[0] || parseInt(min), filters?.[1] || parseInt(max)]"
      @data-selected="getFilters($event)"
      @close="displaySelectFull = false"
    />
    <div
      v-if="!displaySelectFull"
      style="text-align: left"
      class="full-screen bordered-bottom"
    >
      <label
        class="label"
        @click="displaySelectFull = true"
      >{{ label }}</label>
      <div class="main-form">
        <div
          class="segments"
          @click="displaySelectFull = true"
        >
          <div
            v-if="filters != null"
            class="segment"
          >
            <span>{{ $t('statistic.min') }}: {{ filters[0] }} - {{ $t('statistic.max') }}: {{ filters[1] }}</span>
          </div>
        </div>
        <div
          v-if="filters != null"
          class="delete-values"
          @click="[(filters = null), storeData()]"
        >
          <img
            src="@/assets/icons/close.png"
            alt="close"
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectMinMax from '@/components/GenericComponents/Form/SelectMinMax.vue'

export default {
  name: 'BetweenMinMax',
  components: { SelectMinMax },
  props: {
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    search: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: [Array, Object],
      default: () => null
    },
    type_list: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    }
  },
  emits: ['addData'],
  data() {
    return {
      displaySelectFull: false,
      filters: null
    }
  },
  mounted() {
    if (this.defaultValue) {
      this.filters = this.defaultValue
      if (this.filters?.value1 && this.filters?.value2) {
        this.filters = [this.filters.value1, this.filters.value2]
      } else if (this.filters?.[0]?.value?.value1 && this.filters?.[0]?.value?.value2) {
        this.filters = [this.filters[0].value.value1, this.filters[0].value.value2]
      }
      this.storeData()
    }
  },
  methods: {
    getFilters(e) {
      this.filters = e
      this.storeData()
    },
    storeData() {
      this.$emit('addData', {
        value: this.filters
          ? [
            {
              label: this.label,
              value: { value1: this.filters[0], value2: this.filters[1] },
              extra: this.type_list
            }
          ]
          : null,
        name: this.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .full-screen {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 10px 0;

    .label {
      padding-left: 12px;
      color: #777;
      font-size: 0.75rem !important;
      text-align: left;
    }

    .main-form {
      display: flex;
      padding-left: 12px;

      .segments {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;

        .segment {
          font-size: 0.8rem !important;

          > span {
            margin-right: 5px;
          }
        }
      }
    }

    .delete-values {
      padding: 5px;
      place-self: center center;

      > img {
        height: 1rem;
      }
    }
  }
</style>
